import { useEffect } from 'react';
import { navigate } from 'gatsby';

const IndexPage = () => {
    useEffect(() => {
        const browserLang = navigator.language || navigator.userLanguage;
        let langPath = '/de/';

        if (browserLang.startsWith('de')) {
            langPath = '/de/';
        }

        navigate(langPath, { replace: true });
    }, []);

    return null;
};

export default IndexPage;
